import React, { useEffect } from 'react';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import AutoCompleteCustomer from "../../CustomInputs/AutoCompleteCustomer";

const SelectDate = ({
  date,
  setDate,
  setFilter,
  isSmall,
  customRange,
  setCustomRange,
}) => {
  const handleChange = (event) => {
    const value = event.target.value;
    setDate(value);
    
    if (value !== 'custom') {
      setCustomRange({start: '', end: ''});
      setFilter(prev => ({
        ...prev, 
        start: null, 
        end: null, 
        all: value === 'all',
        dateValue: value
      }));
    } else {
      setCustomRange({start: '', end: ''});
    }
  };

  // Обновляем фильтр только когда оба поля заполнены
  useEffect(() => {
    if (date === 'custom' && customRange.start && customRange.end) {
      setFilter(prev => ({
        ...prev, 
        start: customRange.start, 
        end: customRange.end,
        all: false
      }));
    }
  }, [customRange.start, customRange.end, date, setFilter]);

  return (
    <Box sx={{
      display: 'flex', 
      flexWrap: 'wrap', 
      alignItems: 'flex-start', 
      gap: 2
    }}>
      {/* Date Select */}
      <FormControl sx={{ minWidth: 250 }}>
        <InputLabel id="label-date-1">Date</InputLabel>
        <Select
          value={date}
          onChange={handleChange}
          labelId='label-date'
          label='Date'
          defaultValue='custom'
        >
          <MenuItem value='custom'>Custom Range</MenuItem>
          <MenuItem value={7}>Next Week</MenuItem>
          <MenuItem value={-7}>Last Week</MenuItem>
          <MenuItem value={14}>Next 2 week</MenuItem>
          <MenuItem value={-14}>Last 2 week</MenuItem>
          <MenuItem value={30}>Next 30 days</MenuItem>
          <MenuItem value={-30}>Last 30 days</MenuItem>
          <MenuItem value={183}>Next Half a year</MenuItem>
          <MenuItem value={-183}>Last Half a year</MenuItem>
          <MenuItem value={365}>Next Year</MenuItem>
          <MenuItem value={-365}>Last Year</MenuItem>
          <MenuItem value='all'>All</MenuItem>
        </Select>
      </FormControl>
      
      {/* Custom Date Range */}
      {date === 'custom' && (
        <>
          <TextField
            label="Start Date"
            type="date"
            value={customRange.start}
            onChange={(e) => setCustomRange(prev => ({...prev, start: e.target.value}))}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 170 }}
          />
          <TextField
            label="End Date"
            type="date"
            value={customRange.end}
            onChange={(e) => setCustomRange(prev => ({...prev, end: e.target.value}))}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 170 }}
          />
        </>
      )}
      
      {/* Customer Autocomplete */}
      <AutoCompleteCustomer
        setCustomerId={(value) => setFilter(e => ({...e, customerId: value}))}
        style={{xs: '250px', sm: '300px'}}
        m='0'
      />
    </Box>
  );
}

export default SelectDate;